import {
	fetchUserAsTerm,
	fetchAsTermList,
	userAvailableAsHistoryList,
	userAllAsHistoryList,
} from '@/api';

const namespaced = true;

const state = {
	userAsTerm: {},
	asTermList: [],
	userAsStampList: [],
	userAsList: [],
};

const getters = {
	userAsTerm(state) {
		return state.userAsTerm;
	},
	asTermList(state) {
		return state.asTermList;
	},
	userAsStampList(state) {
		return state.userAsStampList;
	},
	userAsList(state) {
		return state.userAsList;
	},
};

const mutations = {
	getUserAsTerm(state, data) {
		state.userAsTerm = data;
	},
	initUserAsTerm(state) {
		state.userAsTerm = {};
	},
	getAsTermList(state, list) {
		state.asTermList = list;
	},
	setUserAsStampList(state, list) {
		state.userAsStampList = list;
	},
	setUserAsList(state, { page, list }) {
		page === 1
			? (state.userAsList = list)
			: (state.userAsList = [...state.userAsList, ...list]);
	},
	initUserAsList(state) {
		state.userAsList = [];
	},
};

const actions = {
	getUserAsTerm({ commit }, payload) {
		return fetchUserAsTerm(payload)
			.then(response => {
				response.data.code === '00000'
					? commit('getUserAsTerm', response.data.userAsTerm)
					: commit('initUserAsTerm');
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getAsTermList({ commit }) {
		return fetchAsTermList()
			.then(response => {
				commit('getAsTermList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getUserAsStampList({ commit }, payload) {
		return userAvailableAsHistoryList(payload)
			.then(response => {
				commit('setUserAsStampList', response.data.availableAsList);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getUserAsList({ commit }, payload) {
		return userAllAsHistoryList(payload)
			.then(response => {
				if (response.data.code === '00000')
					commit('setUserAsList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	initUserAsList({ commit }) {
		commit('initUserAsList');
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
